// Mycart copy.js
// ~~~~~~~~~~~~~~~~~~~~~~~~~~ TIGMANSHU'S CODE ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

import $ from "jquery";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, Redirect } from "react-router-dom";
import { getLanguage } from "react-switch-lang";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import { Modal, CloseButton } from "react-bootstrap";
import Footer from "./Footer.js";
import NewHeader from "./newHeader.js";
import Stepper from "./Stepper";
import EventTable from "./components/_EventTable";
import FixedBottomSummary from "./components/_FixedBottomSummary";
import MagazineTable from "./components/_MagazineTable";
import ProductTable from "./components/_ProductTable";
import * as myConstClass from "./constant.js";
import { BASE_URL, getProductCartCount, getCartDisplayCount } from "./constant.js";
import { routes } from "./routes.constants";
import {
  getCartTotalPriceAsync,
  resetMachineTestMode,
  selectCheckoutSteps,
  selectTotalPrice,
  setHasEvents,
  setHasProducts,
  setMachineTestSteps,
  stepsEnum,
} from "./store/checkoutSlice";
import "./yourCart.css";

const Mycart = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const checkoutSteps = useSelector(selectCheckoutSteps);const reduxTotalPrice = useSelector(selectTotalPrice);
const user_id = localStorage.getItem('user_id');
const totalPrice = (user_id && user_id > 0)
  ? reduxTotalPrice
  : (() => {
      const guestProducts = JSON.parse(localStorage.getItem('guest_cart_products') || '[]');
      const guestMagazines = JSON.parse(localStorage.getItem('guest_cart_magazines') || '[]');
      const guestMachineTests = JSON.parse(localStorage.getItem('guest_mt_cart') || '[]');
      const productTotal = guestProducts.reduce((sum, product) => sum + (parseFloat(product.price || 0) * parseInt(product.quantity || 1)), 0);
      const magazineTotal = guestMagazines.reduce((sum, mag) => sum + parseFloat(mag.donation_contribution || mag.price || 0), 0);
      const machineTestTotal = guestMachineTests.reduce((sum, mt) => {
        const parentPrice = parseFloat(mt.price || 0) * parseInt(mt.parent || 0);
        const childPrice = parseFloat(mt.child_price || mt.price || 0) * parseInt(mt.child || 0);
        return sum + parentPrice + childPrice;
      }, 0);
      return productTotal + magazineTotal + machineTestTotal;
    })();

  const [cartItems, setCartItems] = useState([]);
  const [eventItems, setEventItems] = useState([]);
  const [magazineItems, setMagazineItems] = useState([]);
  const [isCheckingStock, setIsCheckingStock] = useState(false);
  const [stockCheckResult, setStockCheckResult] = useState(null);
  const [isPreloadingStock, setIsPreloadingStock] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [hasMachineTestsInCart, setHasMachineTestsInCart] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const user_id = localStorage.getItem("user_id");
    if (user_id) {
      localStorage.removeItem("error");
    }
    // Guest users can now view their cart without logging in
  }, [])

  // Clear event-related localStorage when landing on cart
  useEffect(() => {
    // Always clear event-related keys when user lands on cart
    const keys = [
      'booking_event_guest',
      'booking_event',
      'event_checkout_in_progress',
      'event_checkout_proceeding',
      'guest_participants',
      'guest_event_participants',
      'selected_participant_types'
    ];
    keys.forEach((k) => {
      try { localStorage.removeItem(k); } catch (e) { /* ignore */ }
    });
  }, []);

  // Calculate cart count based on actual cart state
  function calculateCartCount() {
    const user_id = localStorage.getItem("user_id");
    
    if (user_id && user_id > 0) {
      // For logged-in users, count from cartItems state (which is already filtered)
      return cartItems.length;
    } else {
      // For guest users, count products with qty > 0 from all sources
      const guestProducts = JSON.parse(localStorage.getItem('guest_cart_products') || '[]').filter(item => parseInt(item.quantity || 0) > 0);
      const guestMagazines = JSON.parse(localStorage.getItem('guest_cart_magazines') || '[]');
      const guestEvents = JSON.parse(localStorage.getItem('guest_cart_events') || '[]');
      const guestMachineTests = JSON.parse(localStorage.getItem('guest_mt_cart') || '[]');
      return guestProducts.length + guestMagazines.length + guestEvents.length + guestMachineTests.length;
    }
  }

  useEffect(() => {
    // Check for machine tests and set appropriate steps
    const initializeCart = async () => {
      // First, fetch all data
      await fetchData();
      
      // After fetching data, check if cart has machine tests
      const user_id = localStorage.getItem("user_id");
      let hasMachineTests = false;
      
      if (user_id && user_id > 0) {
        // Logged-in user: Check the fetched backend data (eventItems state will be updated after fetchData)
        // We need to re-check after state updates, so we'll fetch again inline
        try {
          const machineTestItemsUrl = `${BASE_URL}cart/getAllMyCartDataForMachineTestEvents/${user_id}/${getLanguage()}`;
          const machineTestItemsData = await (await fetch(machineTestItemsUrl)).json();
          hasMachineTests = machineTestItemsData && machineTestItemsData.length > 0;
        } catch (error) {
        }
      } else {
        // Guest user: Check localStorage for machine tests
        const guestMachineTests = JSON.parse(localStorage.getItem('guest_mt_cart') || '[]');
        hasMachineTests = guestMachineTests.length > 0;
      }
      
      // Set appropriate steps based on cart contents
      if (hasMachineTests) {
        dispatch(setMachineTestSteps());
      } else {
        dispatch(resetMachineTestMode());
      }
      
      dispatch(getCartTotalPriceAsync());
      
      // Mark as initialized so count calculations start now
      setIsInitialized(true);
      
      setTimeout(() => {
        preloadStockStatus();
      }, 800); 
    };
    
    initializeCart();
  }, [dispatch]);

  // Update cart count only after initialization is complete, to prevent intermediate flickering
  useEffect(() => {
    if (!isInitialized) return; // Don't update until data is fully loaded
    
    const finalCount = calculateCartCount();
    $(".lblCartCount").html(finalCount);
    localStorage.setItem('cached_cart_count', finalCount.toString());
    if (finalCount === 0) {
      $("#ContinueToCheckoutMainDiv").css("display", "none");
    } else {
      $("#ContinueToCheckoutMainDiv").css("display", "block");
    }
  }, [isInitialized, cartItems, eventItems, magazineItems]);

  // Mycart.js
  useEffect(() => {
    const user_id = localStorage.getItem('user_id');
    const guestAllowed = localStorage.getItem('guest_allowed') === 'true';

    if (!user_id && !guestAllowed) {
      // not allowed -> store return path and redirect to signin
      localStorage.setItem('redirect_after_login', window.location.pathname);
      history.replace('/signin');
      return;
    }

    // cleanup when leaving cart: revoke guest access so future entries force login
    // BUT: preserve flag if user is proceeding to checkout (not backing out)
    return () => {
      const isProceedingToCheckout = localStorage.getItem('cart_proceeding_to_checkout');
      
      // Only remove guest_allowed if user is backing out (not proceeding forward)
      if (!isProceedingToCheckout && localStorage.getItem('guest_allowed')) {
        localStorage.removeItem('guest_allowed');
      }
      
      // Clear the proceeding flag after checking
      if (isProceedingToCheckout) {
        localStorage.removeItem('cart_proceeding_to_checkout');
      }
    };
  }, []); // run on mount/unmount

  

  // Check for cart conflict message after login
  useEffect(() => {
    const conflictMessage = localStorage.getItem('cart_conflict_message');
    if (conflictMessage) {
      // Show the conflict warning on cart page
      setTimeout(() => {
        toast(conflictMessage, { 
          containerId: 'B', 
          type: toast.TYPE.ERROR, 
          autoClose: 8000
        });
      }, 500); // Small delay to ensure page is fully loaded
      
      // Clear the message so it doesn't show again
      localStorage.removeItem('cart_conflict_message');
    }
  }, []); // run once on mount

  useEffect(() => {
    if (cartItems.length > 0 && !isPreloadingStock && stockCheckResult !== null) {
      setStockCheckResult(null);
      preloadStockStatus();
    }
  }, [cartItems.length, isPreloadingStock, stockCheckResult]); 
  async function getCartItemsCount() {
    const finalCount = calculateCartCount();
    $(".lblCartCount").html(finalCount);
    localStorage.setItem('cached_cart_count', finalCount.toString());
  }

  async function fetchProducts() {
    try {
      const user_id = localStorage.getItem("user_id");
      
      if (user_id && user_id > 0) {
        // Logged-in user: fetch from backend
        const produtsUrl = `${BASE_URL}cart/getAllMyCartData/${user_id}/${getLanguage()}`;
        const productsData = await (await fetch(produtsUrl)).json();

        if (productsData.length) {
          dispatch(setHasProducts(true));
        } else {
          dispatch(setHasProducts(false));
        }

        setCartItems(productsData);
        return productsData;
      } else {
        // Guest user: load from localStorage
        const guestProducts = JSON.parse(localStorage.getItem('guest_cart_products') || '[]');
        
        if (guestProducts.length) {
          dispatch(setHasProducts(true));
        } else {
          dispatch(setHasProducts(false));
        }
        
        setCartItems(guestProducts);
        return guestProducts;
      }
    } catch (error) {
      return [];
    }
  }

  async function fetchEvents() {
    try {
      const user_id = localStorage.getItem("user_id");
      if (user_id && user_id > 0) {
        // Logged-in user: fetch from backend
        const eventItemsUrl = `${BASE_URL}cart/getAllMyCartDataForEvents/${user_id}/${getLanguage()}`;
        const machineTestItemsUrl = `${BASE_URL}cart/getAllMyCartDataForMachineTestEvents/${user_id}/${getLanguage()}`;
        const [eventItemsData, machineTestItemsData] = await Promise.all([
          (await fetch(eventItemsUrl)).json(),
          (await fetch(machineTestItemsUrl)).json(),
        ]);
        const combined = [...(eventItemsData || []), ...(machineTestItemsData || [])];
        if (combined.length > 0) {
          dispatch(setHasEvents(true));
        } else {
          dispatch(setHasEvents(false));
        }
        setEventItems(combined);
        return combined;
      } else {
        // Guest user: load both guest_cart_events and guest_mt_cart, group and display both
        const guestEvents = JSON.parse(localStorage.getItem('guest_cart_events') || '[]');
        const guestMachineTests = JSON.parse(localStorage.getItem('guest_mt_cart') || '[]');
        const transformedEvents = [];
        // Group regular events
        if (guestEvents.length > 0) {
          const groupedEvents = {};
          guestEvents.forEach(event => {
            const eventType = event.event_type || 'Event';
            if (!groupedEvents[eventType]) {
              groupedEvents[eventType] = {
                event_type: eventType,
                event_type_id: event.event_type_id || 1,
                arr_cart: []
              };
            }
            groupedEvents[eventType].arr_cart.push({
              event_id: event.event_id,
              schedule_id: event.schedule_id,
              title: event.title,
              parent: event.parent || 0,
              child: event.child || 0,
              first_price: event.price || 0,
              second_price: event.child_price || event.price || 0,
              venue_address: event.venue_address || '',
            });
          });
          transformedEvents.push(...Object.values(groupedEvents));
        }
        // Group machine tests as a separate event group
        if (guestMachineTests.length > 0) {
          transformedEvents.push({
            event_type: 'Machine Test',
            event_type_id: 3,
            arr_cart: guestMachineTests.map(mt => ({
              event_id: mt.event_id,
              schedule_id: mt.schedule_id,
              title: mt.title,
              parent: mt.parent || 0,
              child: mt.child || 0,
              first_price: mt.price || 0,
              second_price: mt.child_price || mt.price || 0,
              venue_address: mt.venue_address || ''
            }))
          });
        }
        if (transformedEvents.length > 0) {
          dispatch(setHasEvents(true));
        } else {
          dispatch(setHasEvents(false));
        }
        setEventItems(transformedEvents);
        return transformedEvents;
      }
    } catch (error) {
      return [];
    }
  }

  // Magazine fetching - magazines can coexist with products now
  async function fetchMagazines() {
    try {
      const user_id = localStorage.getItem("user_id");
      
      if (user_id && user_id > 0) {
        // Logged-in user: fetch from backend
        const magazinesUrl = `${BASE_URL}cart/getAllMyCartDataForMagazine/${user_id}/${getLanguage()}`;
        const magazinesData = await (await fetch(magazinesUrl)).json();

        setMagazineItems(magazinesData);
        return magazinesData;
      } else {
        // Guest user: load from localStorage and transform to expected structure
        const guestMagazines = JSON.parse(localStorage.getItem('guest_cart_magazines') || '[]');
        
        // Transform to match backend structure
        const transformedMagazines = guestMagazines.map(mag => ({
          ...mag,
          magazine_title: mag.title,
          subscription_type: 'Guest Subscription',
          package_title: mag.package_title || 'Subscription Package',
          donation_contribution: mag.price || 0,
        }));
        
        setMagazineItems(transformedMagazines);
        return transformedMagazines;
      }
    } catch (error) {
      return [];
    }
  }

  async function fetchData() {
    try {
      const [events, products, magazines] = await Promise.all([
        fetchEvents(),
        fetchProducts(),
        fetchMagazines(),
      ]);
    } catch (error) {
    }
  }


  async function preloadStockStatus() {
    try {
      setIsPreloadingStock(true);
      const result = await checkProductsStockInternal();
      setStockCheckResult(result);
      setIsPreloadingStock(false);
    } catch (error) {
      setIsPreloadingStock(false);
    }
  }


  async function checkProductsStockInternal() {
    try {
      const user_id = localStorage.getItem("user_id");
      const language = getLanguage();
      
      // Get cart products - fetch if state is empty
      let cartProducts = [];
      if (cartItems.length > 0) {
        
        cartProducts = cartItems;
      } else {
        
        if (user_id && user_id > 0) {
          const cartUrl = `${BASE_URL}cart/getAllMyCartData/${user_id}/${language}`;
          cartProducts = await (await fetch(cartUrl)).json();
        } else {
          cartProducts = JSON.parse(localStorage.getItem('guest_cart_products') || '[]');
        }
      }
      
      if (cartProducts.length === 0) {
        return { allInStock: true, message: '' };
      }
      
      // Fetch all products to get stock status
      const productsUrl = `${BASE_URL}product/getProductsFrontEnd/${language}/0/0/0/0/${user_id || 0}`;
      const productsResponse = await fetch(productsUrl);
      const productsData = await productsResponse.json();
      
      // Build a map of product_id -> out_of_stock status
      const productStockMap = {};
      if (productsData && productsData.length > 0) {
        productsData.forEach(category => {
          if (category.arr_product && category.arr_product.length > 0) {
            category.arr_product.forEach(prod => {
              productStockMap[prod.product_id] = {
                out_of_stock: prod.out_of_stock,
                title: prod.title || prod.short_title
              };
            });
          }
        });
      }
      
      // Check which cart products are out of stock
      const outOfStockProducts = [];
      cartProducts.forEach(cartItem => {
        const productId = cartItem.product_id;
        if (productStockMap[productId] && productStockMap[productId].out_of_stock === '1') {
          outOfStockProducts.push(productStockMap[productId].title || cartItem.title);
        }
      });
      
      if (outOfStockProducts.length > 0) {
        const message = language === 'en' 
          ? `The following product(s) are out of stock: ${outOfStockProducts.join(', ')}. Please remove them from your cart to proceed.`
          : `खालील उत्पादने स्टॉकमध्ये नाहीत: ${outOfStockProducts.join(', ')}. पुढे जाण्यासाठी कृपया त्यांना तुमच्या कार्टमधून काढा.`;
        return { allInStock: false, message };
      }
      
      return { allInStock: true, message: '' };
    } catch (error) {
      // In case of error, allow to proceed (don't block user)
      return { allInStock: true, message: '' };
    }
  }

  async function checkProductsStock() {
    if (stockCheckResult !== null) {
      return stockCheckResult;
    }
    return await checkProductsStockInternal();
  }

  function handleConfirmation() {
    const url = hasMachineTestsInCart
      ? "TnCMachineTestEvents.pdf"
      : "TnCEvents.pdf";

    const link = document.createElement("a");
    link.rel = "noopener noreferrer";
    link.href = url;
    link.target = "_blank";
    link.download = hasMachineTestsInCart
      ? "Machine-Test-Terms.pdf"
      : "Events-Terms.pdf";

    document.body.appendChild(link);
    link.click();

    // iOS / Safari fallback
    window.open(url, "_blank", "toolbar=no,location=no,status=no,menubar=no");
  }


  const handleProceed = async () => {
    try {
      // Check if products are out of stock before proceeding
      if (cartItems.length > 0) {
        let outOfStockCheck = stockCheckResult;
        if (!outOfStockCheck) {
          setIsCheckingStock(true);
          outOfStockCheck = await checkProductsStockInternal();
          setIsCheckingStock(false);
        }
        if (!outOfStockCheck.allInStock) {
          toast(outOfStockCheck.message, { containerId: 'B', type: toast.TYPE.ERROR });
          return;
        }
      }
      
      // Check if cart has machine tests
      const user_id = localStorage.getItem("user_id");
      let hasMachineTests = false;
      
      if (user_id && user_id > 0) {
        // Logged-in user: Fetch machine tests directly from backend to ensure fresh data
        try {
          const machineTestItemsUrl = `${BASE_URL}cart/getAllMyCartDataForMachineTestEvents/${user_id}/${getLanguage()}`;
          const machineTestItemsData = await (await fetch(machineTestItemsUrl)).json();
          hasMachineTests = machineTestItemsData && machineTestItemsData.length > 0;
        } catch (error) {
          // Fallback: check eventItems state
          hasMachineTests = eventItems.some(eventGroup => 
            eventGroup.event_type === 'Machine Test' || eventGroup.event_type_id === 3
          );
        }
      } else {
        // Guest user: check localStorage
        const guestMachineTests = JSON.parse(localStorage.getItem('guest_mt_cart') || '[]');
        hasMachineTests = guestMachineTests.length > 0;
      }
      
      // Mark that user is proceeding to checkout (not backing out)
      localStorage.setItem('cart_proceeding_to_checkout', 'true');

      //STORE machine test info for modal & PDF
      setHasMachineTestsInCart(hasMachineTests);

      // If cart has machine tests, show PDF download modal first
      if (hasMachineTests) {
        
        setShowModal(true);
      } else {
        
        // Otherwise, go directly to address page
        history.push("/address");
      }
    } catch (error) {
      setIsCheckingStock(false);
    }
  };

  const handleClearCart = async () => {
    const user_id = localStorage.getItem("user_id");
    const language = getLanguage();

    let are_you_sure = "Are you sure?";
    let revert = "Do you want to remove all items from the cart?";
    let deleteConfirm = "Yes, clear cart!";
    let cancel = "Cancel";
    if (language === "ma") {
      are_you_sure = "तुम्हाला खात्री आहे?";
      revert = "तुम्ही कार्टमधील सर्व वस्तू/उपक्रम काढून टाकू इच्छिता?";
      deleteConfirm = "होय, कार्ट साफ करा";
      cancel = "नाही";
    }

    try {
      const result = await Swal.fire({
        title: are_you_sure,
        text: revert,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        cancelButtonText: cancel,
        confirmButtonText: deleteConfirm,
      });

      if (!result.value) return null;

      if (user_id && user_id > 0) {
        // Logged-in user: call clearCart API
        const clearUrl = `${BASE_URL}cart/clearCart/${user_id}`;
        const clearResponse = await fetch(clearUrl);
        const clearData = await clearResponse.json();

        if (clearData.status === "true") {
          toast(clearData.message, {
            containerId: "B",
            type: toast.TYPE.SUCCESS,
          });

          // Clear machine tests from localStorage (since they're stored there for all users)
          localStorage.removeItem('guest_cart_events');
          localStorage.setItem('cartCount', 0);

          // Refresh all cart data
          setCartItems([]);
          setEventItems([]);
          setMagazineItems([]);
          dispatch(setHasProducts(false));
          dispatch(setHasEvents(false));
          dispatch(getCartTotalPriceAsync());
          getCartItemsCount();
        } else {
          toast(clearData.message || "Error clearing cart", {
            containerId: "B",
            type: toast.TYPE.ERROR,
          });
        }
      } else {
        // Guest user: clear localStorage
        localStorage.removeItem('guest_cart_products');
        localStorage.removeItem('guest_cart_magazines');
        localStorage.removeItem('guest_cart_events');
        localStorage.removeItem('guest_mt_cart'); // Clear machine tests for guests
        localStorage.setItem('cartCount', 0);

        setCartItems([]);
        setEventItems([]);
        setMagazineItems([]);
        dispatch(setHasProducts(false));
        dispatch(setHasEvents(false));
        dispatch(getCartTotalPriceAsync());

        $(".lblCartCount").html(0);
        
        const successMsg = language === 'en' 
          ? 'All items removed from cart successfully'
          : 'कार्टमधील सर्व वस्तू यशस्वीरित्या काढल्या';
        
        toast(successMsg, {
          containerId: "B",
          type: toast.TYPE.SUCCESS,
        });
      }
    } catch (error) {
      toast("Error clearing cart. Please try again.", {
        containerId: "B",
        type: toast.TYPE.ERROR,
      });
    }
  };

  return (
    <>
      <ToastContainer />
      <NewHeader />

      <div className="mt-4 pt-2 mt-sm-4 pt-sm-4 mt-md-4 pt-md-4 mt-xl-1">
        <Stepper steps={checkoutSteps} currentStep={stepsEnum[0]} />
      </div>
      <div className="container">
        <EventTable
          eventItems={eventItems}
          setEventItems={setEventItems}
          onDataChange={() => {
            dispatch(getCartTotalPriceAsync());
          }}
        />

        <ProductTable
          cartItems={cartItems}
          setCartItems={setCartItems}
          onDataChange={() => {
            dispatch(getCartTotalPriceAsync());
          }}
        />

        {/* MagazineTable - magazines can now be in cart */}
        <MagazineTable
          magazineItems={magazineItems}
          setMagazineItems={setMagazineItems}
          onDataChange={() => {
            dispatch(getCartTotalPriceAsync());
          }}
        />
      </div>
      {/* Check for cartItems, eventItems, or magazineItems since all can be in cart now */}
      {(cartItems?.length > 0 || eventItems?.length > 0 || magazineItems?.length > 0) ? (
        <>
          <FixedBottomSummary
            totalPrice={totalPrice}
            leftContent={
              <button
                className="btn btn-outline-danger btn-sm px-2 py-1 d-inline-flex align-items-center"
                onClick={handleClearCart}
                style={{ 
                  borderWidth: '1px',
                  fontWeight: '500',
                  fontSize: '0.85rem'
                }}
              >
                <i className="fas fa-trash-alt mr-2"></i>
                {getLanguage() === 'en' ? 'Remove All Items' : 'सर्व वस्तू काढा'}
              </button>
            }
          >
            <div>
              <button
                className="w-100 btn py-2 proceed-button text-nowrap"
                onClick={handleProceed}
                disabled={isCheckingStock}
              >
                {isCheckingStock ? (
                  <>
                    <span className="mr-1 fw-bold">
                      {getLanguage() === 'en' 
                        ? 'Checking Stock Availability...' 
                        : 'स्टॉक उपलब्धता तपासत आहे...'}
                    </span>
                    <i className="fas fa-spinner fa-spin"></i>
                  </>
                ) : (
                  <>
                    <span className="mr-1 fw-bold">Next</span>{" "}
                    <i className="fas fa-chevron-right fw-bold"></i>
                  </>
                )}
              </button>
            </div>
          </FixedBottomSummary>
        </>
      ) : (
        <>
          <div className="container my-4 px-3 flex-wrap">
            Your Cart is Currently Empty. Add Some{" "}
            <Link to={routes.moreProducts}>Products</Link> and visit here to
            Checkout
          </div>
        </>
      )}
      
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        className="modal-box"
      >
        <Modal.Header>
          <Modal.Title>Instructions</Modal.Title>
          <CloseButton
            className="btn-sm"
            onClick={() => {
              setShowModal(false);
            }}
          ></CloseButton>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          {hasMachineTestsInCart ? (
            <div>
              <b>Important Instructions about Machine Tests & Therapy</b>
              <ol className="pl-3 mt-2">
                <li>
                  The date &amp; time of the test/therapy needs to be booked by contacting the Machine Test Department at the main centre, Lonavla. The booking should be done about 1.5 to 2 months in advance.
                </li>
                <li>
                  It takes around two to three hours to conduct the tests along with counselling.
                </li>
                <li>
                  Each test includes: conducting the test, analyzing the results, generating the report, explaining the test results and giving remedies during counselling session.
                </li>
                <li>
                  After booking a test/therapy, the total donation contribution needs to be paid at the local or main centre within a week, otherwise the booking gets cancelled.
                </li>
              </ol>
            </div>
          ) : (
            <div>
              <b>
                Very Important Instructions for Events (Please download & read the
                pdf to avoid inconvenience){" "}
              </b>
              <br />
              <ul className="pl-3">
                <li>
                  Arrival for Course at Lonavla by 9.00 am. Vehicle available for
                  Trains from Mumbai: Indrayani, Intercity, Deccan Express & local
                  train from Pune at 9:30 am outside platform no.1 (Lonavla West).
                  Courses end by 4.30 pm to 5.00 pm, Vehicle is available to
                  Railway or Bus station.
                </li>
                <li>
                  For Residential Courses, Do pack separate bags (with clothing,
                  tooth paste-brush, soap, oil etc.) for children and parents.
                  Lodging for boys, girls, men, women parents is separate
                  (Exception Mendu-Kranti small kids). Do carry your medicines
                  along. Clinic is available.
                </li>
                <li>
                  Do keep your PAN /AADHAR Nos. handy while coming for the course.
                </li>
              </ul>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <a
            href="/address"
            onClick={() => {
              handleConfirmation();
            }}
            className={" btn btn-primary agree-tc "}
          >
            <span className="me-2 mr-2">
              Download Events Terms & Conditions
            </span>

            <i class="fas fa-file-download"></i>
          </a>
        </Modal.Footer>
      </Modal>
      
      <Footer />
    </>
  );
};

export default Mycart;
